
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table, TableRowsSelect } from "@common/src/utils/decorator";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import CouponContent from "@/views/marketing/components/coupon-discount-content.vue";
import dayjs from "dayjs";
import { checkMoneyEl } from "@common/src/utils/verify";
import t from "@common/src/i18n/t";

const marketing = namespace("marketing");
const coupon = namespace("coupon");
const employee = namespace("employee");
const common_app = namespace("common_app");
@Component({
  components: {
    CouponContent
  }
})
@Table("loadListData")
@TableRowsSelect({
  warningMsg: t("setting.choose-payment-method"),
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table"
})
export default class DiscountCoupon extends Vue {
  @marketing.Action queryStaffAccountList;
  @coupon.Action disable;
  @employee.Action createStaffSalaryConfig;
  @employee.Action updateStaffSalarySetting;
  @employee.Action getStaffSalaryTemplate;
  @employee.Action getStaffSalaryConfigPage;
  @employee.Action updateStaffSalaryTemplate;
  @employee.Action deleteStaffSalaryConfig;
  @employee.Action getStaffSalaryConfig;
  @employee.Action updateStaffSalaryConfig;
  @common_app.State lang;
  dayjs = dayjs;
  checkMoneyEl = checkMoneyEl;
  yesMustList = [
    { value: "true", label: t("v210801.yes") },
    {
      value: "false",
      label: t("v210801.no")
    }
  ];
  projectList = [
    {
      value: "increase",
      label: t("v210831.additional-item")
    },
    {
      value: "decrease",
      label: t("v210831.subtraction")
    }
  ];
  defaultTbaleData = {
    itemName: "",
    allowDelete: "true",
    allowEditSort: "true",
    calculationType: "",
    isRequire: "",
    itemCode: "",
    itemSort: ""
  };
  tableData = [];
  showTemplateSet = false;
  hoverRow = undefined;
  showPickingTips = false;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  searchForm = {
    staffName: undefined
  };
  editFlag = false;
  createWageForm = {
    wageSetList: [],
    staffName: undefined,
    baseSalary: "",
    commissionWeight: "5",
    subsidy: "0",
    staffCode: "",
    employee: {
      staffName: "",
      userCode: ""
    },
    configId: ""
  };
  twiceSubsidyRule(rule, value, callback) {
    if (Number(value) < 0 || isNaN(Number(value))) {
      callback(new Error(t("v210831.please-enter-a-rational-subsidy")));
    } else {
      callback();
    }
  }
  subsidyRule = (rule, value, callback) => {
    this.twiceSubsidyRule(rule, value, callback);
  };
  createWageFormRules = {
    employee: [{ required: true, message: t("v210831.please-select-an-employee"), trigger: "blur" }],
    baseSalary: [
      { required: true, message: "请输入基本工资", trigger: "blur" },
      { validator: (rule, value, callback) => checkMoneyEl(value, callback), trigger: "blur" }
    ],
    subsidy: [{ validator: this.subsidyRule, trigger: "blur" }]
  };
  cardTemplateList: any[] = [];
  employeeList = [];
  //计算属性
  get searchList() {
    return [
      {
        label: t("v210801.employee-name"),
        type: "input",
        value: "",
        prop: "staffName"
      }
    ];
  }
  get BooleanLang() {
    return this.lang === "zh-CN" ? false : true;
  }
  created() {
    this.init();
  }
  getVisible() {
    return true;
  }
  async init() {
    this.loadListData();
    this.queryStaffAccountList({ pageNum: 1, pageSize: 1000 }).then(data => {
      this.employeeList = this.$safeValue(data, "data.list", []);
    });
    this.getWageTemplate();
  }
  getWageTemplate() {
    this.getStaffSalaryTemplate().then(res => {
      this.tableData = res.data.map(o => {
        return {
          ...o,
          paramName: o.itemEnName
        };
      });
      this.createWageForm.wageSetList = res.data.slice(3);
    });
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  copyRow = undefined;
  handleComfirmCommand(command) {
    switch (command) {
      case "edit":
        this.$router.push(`/marketing/created-coupon/${this.hoverRow.activityCode}`);
        break;
      case "copy":
        this.$router.push({
          name: "marketingCreatedCouponAdd",
          params: {
            copyRow: this.hoverRow.activityCode
          }
        });
        break;
      default:
        this.confirmUpdateStatus();
      // 完成入库
    }
  }
  onSureDisable(row) {
    this.disable({ activityCode: row.activityCode }).then(res => {
      if (!res.data) {
        this.$message.success(t("setting.disable-success"));
        this.loadListData();
      }
    });
  }
  confirmUpdateStatus() {
    console.log("gg");
  }
  handleSetCurrentRow(visible, row) {
    this.hoverRow = row;
  }
  nameList = [];
  @Table.LoadDataMethod()
  loadListData() {
    return this.getStaffSalaryConfigPage({
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize,
      isEnglish: this.BooleanLang + ""
    }).then(data => {
      this.nameList = data.data.fieldNameList;
      this.cardTemplateList = this.$safeValue(data, "data.list", []);
      return data;
    });
  }
  handleView(row) {
    this.$router.push(`/marketing/look-coupon/${row.activityCode}`);
  }
  createdCoupon() {
    this.getWageTemplate();
    this.showPickingTips = true;
    this.editFlag = false;
    let refs = this.$refs as any;
    if (refs.createWageForm) {
      refs.createWageForm.resetFields();
    }
    this.createWageForm.employee = undefined;
    this.createWageForm.staffName = undefined;
    this.createWageForm.baseSalary = undefined;
    this.createWageForm.commissionWeight = "5";
    this.createWageForm.subsidy = "0";
    this.createWageForm.staffCode = undefined;
  }
  async handleEdit(row) {
    let refs = this.$refs as any;
    if (refs.createWageForm) {
      refs.createWageForm.resetFields();
    }
    // 获取员工工资配置
    const data = await this.getStaffSalaryConfig({ configId: row.configId });
    this.showPickingTips = true;
    this.editFlag = true;
    this.createWageForm.staffName = row.staffName || row[this.nameList[0]];
    this.createWageForm.baseSalary = row.baseSalary || row[this.nameList[1]] || "";
    this.createWageForm.commissionWeight = row.commissionWeight || row[this.nameList[2]] || "";
    this.createWageForm.staffCode = row.staffCode;
    this.createWageForm.configId = row.configId;
    this.createWageForm.employee = {
      staffName: row.staffName,
      userCode: row.staffCode
    };
    let newArr = data.data.filter(item => {
      return (
        item.itemName !== "姓名" &&
        item.itemName !== "基本工资" &&
        item.itemName !== "提成权重" &&
        item.itemEnName !== row[this.nameList[0]] &&
        item.itemEnName !== row[this.nameList[1]] &&
        item.itemEnName !== row[this.nameList[2]]
      );
    });
    this.createWageForm.wageSetList = newArr;
  }
  async saveCreateDeploy() {
    let ref = this.$refs.createWageForm as any;
    ref.validate(async (valid, err) => {
      if (valid) {
        this.createWageForm.staffCode = this.createWageForm.employee.userCode;
        this.createWageForm.staffName = this.createWageForm.employee.staffName || this.createWageForm.staffName;
        let params = {
          // staffCode: this.createWageForm.staffCode,
          configId: this.createWageForm.configId,
          itemList: [
            { itemName: "staffCode", itemValue: this.createWageForm.staffCode },
            { itemName: "姓名", itemValue: this.createWageForm.staffName },
            {
              itemName: "基本工资",
              itemValue: this.createWageForm.baseSalary
            },
            {
              itemName: "提成权重",
              itemValue: this.createWageForm.commissionWeight
            }
          ]
        };
        let filterSetList = this.createWageForm.wageSetList.map(item => {
          return { itemName: item.itemName || "", itemValue: item.itemValue || "" };
        });
        params.itemList.push(...filterSetList);
        if (this.editFlag) {
          const editRes = await this.updateStaffSalaryConfig(params);
          if (editRes.data) {
            this.$message.success(t("v210831.employee-configuration-modified"));
            this.showPickingTips = false;
            this.loadListData();
          } else {
            this.$message.success(editRes.data.message);
          }
        } else {
          const res = await this.createStaffSalaryConfig(params);
          if (res.data) {
            this.$message.success(t("v210831.salary-configuration-of-new-empliyee"));
            this.showPickingTips = false;
            this.loadListData();
          } else {
            this.$message.success(res.data.message);
          }
        }
      } else {
        console.log("[err  ]", err);
      }
    });
  }
  currentRow = undefined;
  async handelDelete(row) {
    const res = await this.deleteStaffSalaryConfig({ configId: row.configId });
    if (res.data) {
      this.$message.success(t("v210831.delete-succeeded"));
      this.loadListData();
    } else {
      console.log("[ err]", res.message);
    }
  }
  templateSet() {
    this.showTemplateSet = true;
  }
  async handleTemplateSure() {
    let params = {
      templateList: this.tableData.map(o => {
        let { paramName, ...otherParams } = o;
        return {
          ...otherParams,
          itemName: o.allowDelete == "true" ? paramName : o.itemName
        };
      })
    };
    const data = await this.updateStaffSalaryTemplate(params);
    if (data.code === "0") {
      this.showTemplateSet = false;
      this.$message.success(t("v210831.salary-configuration-template"));
      this.loadListData();
      this.getWageTemplate(); //更新模板
    } else {
      this.$message.warning(t("v210831.failed-to-update"));
    }
  }
  handleInsert() {
    this.tableData.push({ ...this.defaultTbaleData });
  }
  handleDelete(row, scope) {
    this.tableData = this.tableData.filter((item, index) => {
      return index !== scope.$index;
    });
  }
  handleUp(row, index) {
    let moveObj = this.tableData[index - 1];
    this.tableData[index - 1] = this.tableData[index];
    this.tableData[index] = moveObj;
    this.tableData = [...this.tableData];
  }
  handleDown(row, index) {
    let moveObj = this.tableData[index + 1];
    this.tableData[index + 1] = this.tableData[index];
    this.tableData[index] = moveObj;
    this.tableData = [...this.tableData];
  }
  // frontTranslation(zhKey) {
  //   const langMap = {
  //     姓名: {
  //       "zh-CN": "姓名",
  //       "en-US": "Name",
  //       "ms-MY": "Nama Pekerja",
  //       "th-TH": "ชื่อ",
  //       "vi-VN": "Họ tên"
  //     },
  //     基本工资: {
  //       "zh-CN": "基本工资",
  //       "en-US": "Base Pay",
  //       "ms-MY": "Gaji Asas",
  //       "th-TH": "เงินเดือนพื้นฐาน",
  //       "vi-VN": "Lương cơ bản"
  //     },
  //     提成权重: {
  //       "zh-CN": "提成权重",
  //       "en-US": "Commission Weight",
  //       "ms-MY": "Berat Komisen",
  //       "th-TH": "น้ำหนักคอมมิชชั่น",
  //       "vi-VN": "Trọng số của hoa hồng"
  //     }
  //   };
  //   return langMap?.[zhKey]?.[this.lang] || "-";
  // }
}
